import Input from './input.vue'
export default Input
